import React from 'react'
import { UndoActionsContainer, DrawingToolsContainer } from '../../containers/ToolsContainers/ToolsContainers'
import { UIStyles, surfaces } from '../../theme'
import { FIELD_EDIT_VIEW, FIELD_NEW_VIEW, SAMPLE_LOCATION_VIEW } from '../../actions/viewmode'
import { withTranslator } from '../HOCComponents/withTranslator'
import styled from 'styled-components'
import { Button } from '../UIComponents/StyledButtons'

const DrawingToolbarWrapper = styled.div`
  display: flex;
  position: fixed;
  z-index: 1;
  bottom: 40px;
  flex-direction: column;
  align-items: center;
`

const SideButtonsWrapper = styled.div`
  position: fixed;
  z-index: 1;
  bottom: 28px;
  left: 70px;
  /* Cancel and confirm touch, so they read as one split pill: neutral cancel (red on hover), mint confirm. */
  & > button {
    box-shadow: ${surfaces.floatingPanelShadow};
    transition: background-color 0.15s, color 0.15s, box-shadow 0.15s;
  }
  & > button:first-child {
    background-color: ${UIStyles.deepblueColor3};
    color: ${UIStyles.whiteTransparent08};
    border-radius: 999px 0 0 999px;
    box-shadow: ${surfaces.mapPanelShadow};
  }
  & > button:first-child:hover {
    background-color: ${UIStyles.redColor};
    color: ${UIStyles.whiteColor};
    box-shadow: ${surfaces.floatingPanelShadow};
  }
  & > button:last-child {
    color: ${UIStyles.deepblueColor3};
    border-radius: 0 999px 999px 0;
  }
  & > button:last-child:hover {
    box-shadow: ${surfaces.floatingPanelShadow}, 0 0 0 3px ${UIStyles.mintColorTransparent};
  }
`

class Toolbar extends React.Component {
  render() {
    const {
      isToolbarOpen,
      isTemporalActive,
      isFieldSeasonFormEditorOpen,
      denyFieldSeasonFormGeometryAndSurface,
      confirmFieldSeasonFormGeometryAndSurface,
      t,
      currentLocation,
      validateSampleFormLocation,
      denySampleLocation
    } = this.props
    const currentView = currentLocation.view
    const isDrawingToolBarVisible = currentView === FIELD_EDIT_VIEW || currentView === FIELD_NEW_VIEW
    const isSampleLocationView = currentView === SAMPLE_LOCATION_VIEW
    return (
      <div className={'toolbar drawingToolbar ' + (isToolbarOpen ? 'showed' : '')}>
        {!isTemporalActive && isFieldSeasonFormEditorOpen && isDrawingToolBarVisible && (
          <>
            <DrawingToolbarWrapper>
              <UndoActionsContainer />
              <DrawingToolsContainer />
            </DrawingToolbarWrapper>

            <SideButtonsWrapper>
              <Button label={t('cancel')} onClick={denyFieldSeasonFormGeometryAndSurface} background={UIStyles.redColor} />
              <Button label={t('confirm')} onClick={confirmFieldSeasonFormGeometryAndSurface} testId="confirm-geometry-button" />
            </SideButtonsWrapper>
          </>
        )}
        {isSampleLocationView && (
          <SideButtonsWrapper>
            <Button label={t('cancel')} onClick={denySampleLocation} background={UIStyles.redColor} />
            <Button label={t('confirm')} onClick={validateSampleFormLocation} testId="confirm-geometry-button" />
          </SideButtonsWrapper>
        )}
      </div>
    )
  }
}

export default withTranslator(Toolbar)
